import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ErrorComponent } from '@core/components/error/error.component';
import { SupportedPlatformGuard } from '@core/guards/supported-platform.guard';
import { AdminGuard } from '@core/guards/admin.guard';
import { MemberFirmGuard } from '@core/guards/member-firm.guard';
import { AdminComponent } from './admin/admin.component';
import { NotificationsComponent } from './admin/notifications/notifications.component';
import { UsersComponent } from './admin/users/users.component';

const isIframe = window !== window.parent && !window.opener;

const routes: Routes = [
  {
    path: '',
    canActivate: [SupportedPlatformGuard],
    children: [
      {
        path: '',
        canActivate: [MsalGuard, MemberFirmGuard],
        children: [
          { path: '', loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule) },
          {
            path: 'admin',
            canLoad: [AdminGuard],
            component: AdminComponent,
            children: [
              { path: '', pathMatch: 'full', redirectTo: 'tree_builder' },
              {
                path: 'users',
                component: UsersComponent
              },
              {
                path: 'alerts&notifications',
                component: NotificationsComponent
              },
              {
                path: 'tree_builder',
                loadChildren: () =>
                  import('./admin/tree-builder/tree-builder.module').then(modules => modules.TreeBuilderModule)
              },
              {
                path: 'reports',
                loadChildren: () => import('./admin/reports/reports.module').then(modules => modules.ReportsModule)
              },
              {
                path: 'settings',
                loadChildren: () => import('./admin/settings/settings.module').then(modules => modules.SettingsModule)
              }
            ]
          }
        ]
      }
    ]
  },
  { path: 'error/:code', component: ErrorComponent },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      // relativeLinkResolution: 'legacy',
      initialNavigation: !isIframe ? 'enabledBlocking' : 'enabledNonBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
